/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceWatch = createReactComponent("outline", "device-watch", "IconDeviceWatch", [["path", { "d": "M6 9a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3v-6z", "key": "svg-0" }], ["path", { "d": "M9 18v3h6v-3", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }]]);

export { IconDeviceWatch as default };
//# sourceMappingURL=IconDeviceWatch.mjs.map
